export default __webpack_public_path__ + "static/media/about-welcome.a3c994f6.jpg";